import { Tooltip } from '~/components';
import { useIntegrations } from '~/contexts';
import { useFeatures } from '~/hooks';
import { accountingProviders } from '~/lookups';
import qboIcon from '~/assets/public/qbo-icon.png';
import sageIcon from '~/assets/public/sage-intacct-icon.svg';
import xeroIcon from '~/assets/public/xero-icon.png';
import React from 'react';
import styled from 'styled-components';

const icons = { qbo: qboIcon, xero: xeroIcon, sage: sageIcon };

const Wrapper = styled.div`
  width: 1rem;
  height: 1rem;
  margin-left: 0.5rem;
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
`;

const Image = styled.img`
  width: 1rem;
  height: 1rem;
`;

function getDeepLink(invoice, integrations) {
  switch (invoice.accountingProvider) {
    case 'xero': {
      if (!invoice.xeroInvoiceId) return null;
      const orgCode = integrations.xero?.find((c) => c.id === invoice.accountingConnectionId)?.orgCode;
      return orgCode
        ? `https://go.xero.com/organisationlogin/default.aspx?shortcode=${orgCode}&redirecturl=/AccountsReceivable/View.aspx?InvoiceID=${invoice.xeroInvoiceId}`
        : `https://go.xero.com/app/invoicing/view/${invoice.xeroInvoiceId}`;
    }
    default:
      return null;
  }
}

export default function InvoiceSyncIndicator({ invoice, message }) {
  const integrations = useIntegrations();
  const features = useFeatures();
  if (!invoice.accountingProvider) return null;
  const accountingProviderName = accountingProviders[invoice.accountingProvider].name;

  const deepLink = getDeepLink(invoice, integrations);
  const defaultMessage =
    features.multipleAccountingIntegrations && invoice.accountingConnectionName
      ? `This invoice is in the "${invoice.accountingConnectionName}" instance.`
      : `This invoice is in ${accountingProviderName}.`;

  const handleClick = deepLink
    ? (event) => {
        event.stopPropagation();
        window.open(deepLink, '_blank');
      }
    : undefined;

  return (
    <Wrapper $clickable={!!deepLink} onClick={handleClick}>
      <Tooltip message={message ?? defaultMessage}>
        <Image src={icons[invoice.accountingProvider]} />
      </Tooltip>
    </Wrapper>
  );
}
